import React from 'react';

import TopPage from 'v2/components/Shared/TopPage';

import TransfersTable from './TransfersTable';

function TransferHistory() {
  return (
    <div className='font-[Roboto,Helvetica_Neue,Arial,sans-serif]'>
      <TopPage title='Histórico de Transferências' goBackTo='/producer/financial-statement' />
      <TransfersTable />
    </div>
  );
}

export default TransferHistory;
